module.exports = __webpack_public_path__ + "img/小弹窗(1).9c86181d.jpg";